import {
  createAccountCode,
  loginCode,
  creditCardCode,
  wizardCode,
  suggestionBoxCode,
} from './formsCode';

import {
  createAccountLayout,
  loginLayout,
  creditCardLayout,
  wizardLayout,
  suggestionBoxLayout,
} from './formsLayouts';

export const formsSet = [
  {
    component: createAccountLayout,
    codeTemplate: createAccountCode,
    optionsGroup: [
      {
        label: 'Create Account', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
  {
    component: loginLayout,
    codeTemplate: loginCode,
    optionsGroup: [
      {
        label: 'Login Form', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
  {
    component: creditCardLayout,
    codeTemplate: creditCardCode,
    optionsGroup: [
      {
        label: 'Credit Card Form', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
  {
    component: wizardLayout,
    codeTemplate: wizardCode,
    backgroundColor: 'dark-red',
    optionsGroup: [
      {
        label: 'Wizard Form', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
  {
    component: suggestionBoxLayout,
    codeTemplate: suggestionBoxCode,
    backgroundColor: 'red',
    previewClass: 'no-padding',
    optionsGroup: [
      {
        label: 'Suggestion Box', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/containers/components/Form/constants/formsSet.js